import { createModel } from "xstate/lib/model";
import { registerCreditCard } from "@nju/data-access-portal-payment";
import { IRegisterCreditCardResponse } from "@nju/data-access-portal-payment";
import { ContractError, isError } from "@nju/result";
import { generalErrorMessage } from "@nju/utils";

const model = createModel(
  {
    userId: undefined as string | undefined,
    registrationError: undefined as string | undefined,
  },
  {
    events: {
      SUBMIT: () => {
        return {};
      },
      CARD_REGISTERED: (data: IRegisterCreditCardResponse) => {
        return { data };
      },
      REGISTRATION_ERROR: () => {
        return {};
      },
    },
  },
);
const setRegistrationError = model.assign((_) => {
  return {
    registrationError: generalErrorMessage,
  };
}, "REGISTRATION_ERROR");

export const registerCreditCardMachine = model.createMachine({
  initial: "ready",
  states: {
    ready: {
      on: {
        SUBMIT: "send",
      },
    },
    send: {
      on: {
        CARD_REGISTERED: {
          actions: "onSubmitSuccess",
        },
        REGISTRATION_ERROR: { actions: setRegistrationError, target: "ready" },
      },
      invoke: {
        src: ({ userId }) => {
          return async (callback) => {
            if (!userId) {
              throw new ContractError({
                message: "Missing `userId`",
                extra: { where: "register credit card machine" },
              });
            }
            const result = await registerCreditCard({ userId });
            if (isError(result)) {
              return callback({ type: "REGISTRATION_ERROR" });
            }
            callback({ type: "CARD_REGISTERED", data: result.value });
          };
        },
      },
    },
  },
});
